import styled from 'styled-components';
import { useState, useEffect } from 'react';
import { infoStore } from '../../../store/infoStore';
import { TicketWithUsedButton } from '../../ticket/TicketWithUsedButton';
import { NumberTicket } from '../../ticket/NumberTicket';

export const MainEvent = ({ goOfflineTab }: { goOfflineTab: () => void }) => {
  const { info } = infoStore();
  const [sortedOrder, setSortedOrder] = useState<number[] | null>(null);

  useEffect(() => {
    // 최초 마운트 시에만 정렬 순서 저장
    if (info.userTicketInfo && !sortedOrder) {
      const sorted = [...info.userTicketInfo]
        .sort((a, b) => {
          if (a.usedYn === 'Y' && b.usedYn !== 'Y') return 1;
          if (a.usedYn !== 'Y' && b.usedYn === 'Y') return -1;
          return 0;
        })
        .map((t) => t.ticketNo);
      setSortedOrder(sorted);
    }
  }, [info.userTicketInfo, sortedOrder]);

  // 저장된 순서대로 티켓 렌더링 (usedYn은 실시간 반영)
  const ticketsToRender = sortedOrder
    ?.map((ticketNo) => info.userTicketInfo?.find((t) => t.ticketNo === ticketNo))
    .filter(Boolean);

  return (
    <>
      <ImgContainer>
        {info.ticketUseYn === 'Y' ? (
          <>
            <WelcomeText>
              <TicketTitle>오프라인 이벤트 참가권 획득을 축하합니다!</TicketTitle>
              보유 참가권 : {info.userTicketInfo?.length} 장 / 사용 참가권 :{' '}
              {info.userTicketInfo?.filter((ticket) => ticket.usedYn === 'Y').length} 장
            </WelcomeText>
          </>
        ) : (
          <WelcomeText>
            참가권 사용하기는 <span>오프라인 이벤트 당일부터</span> 보여집니다.
            <br /> 보유 참가권 : {info.userTicketInfo?.length} 장 / 사용 참가권 :{' '}
            {info.userTicketInfo?.filter((ticket) => ticket.usedYn === 'Y').length} 장
          </WelcomeText>
        )}
      </ImgContainer>
      <BottomInfoContainer>
        {ticketsToRender?.map((cnt) => {
          if (!cnt) return null;
          if (info.ticketUseYn === 'Y')
            return (
              <TicketWithUsedButton
                key={cnt.ticketNo}
                ticketNumber={cnt.ticketNo}
                isUsed={cnt.usedYn}
              />
            );

          return <NumberTicket key={cnt.ticketNo} cnt={cnt.ticketNo} />;
        })}

        <TicketDetailContainer>
          <TicketDetailText>토너먼트 참가 안내에서 상세 일정을 확인해주세요.</TicketDetailText>
        </TicketDetailContainer>
      </BottomInfoContainer>

      <BottomTabContainer>
        <GoOfflineEventDetailBtn onClick={goOfflineTab}>
          오프라인 이벤트 참가안내
        </GoOfflineEventDetailBtn>
      </BottomTabContainer>
    </>
  );
};

const TicketTitle = styled.h4`
  color: #fed381;
  text-align: center;
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  font-family: 'Noto Sans';
  font-size: 21px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 142.857% */
  letter-spacing: -1.47px;
`;

const WelcomeText = styled.h4`
  font-family: 'Gmarket';
  font-weight: 400;
  letter-spacing: -0.06em;
  color: rgba(255, 255, 255, 0.6);
  text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);

  font-size: 16px;
  line-height: 22px;
  text-align: center;

  span {
    font-weight: 600;
  }
`;

const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 13px;
  margin-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
`;

const BottomInfoContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  padding-left: 20px;
  padding-right: 20px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  padding-bottom: 130px;
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(90deg, rgba(25, 36, 255, 0.85) 39.5%, rgba(77, 14, 166, 0.85) 100%);

  backdrop-filter: blur(25px);
`;

const GoOfflineEventDetailBtn = styled.button`
  height: 100%;
  left: 0%;
  width: 100%;
  height: 70px;

  font-weight: 700;
  font-size: 21px;
  line-height: 24px;
  letter-spacing: -0.04em;

  color: #ffffff;

  background: rgba(0, 58, 146, 0.85);
`;

const TicketDetailContainer = styled.ul`
  padding-left: 10px;
  margin: 0;
  margin-top: 10px;
`;

const TicketDetailText = styled.li`
  font-weight: 500;
  letter-spacing: -0.04em;

  color: #939393;

  font-size: 16px;
  line-height: 24px;
`;
